import React, { Component } from "react";
import { SwipeableDrawer } from "@material-ui/core";
import WaitListDrawerContent from "./WaitListDrawerContent";
import { withRouter } from "react-router";

class WaitList extends Component {
  render() {
    return (
      <div className="w-100">
        <SwipeableDrawer
          anchor="bottom"
          open={this.props.drawerOpen}
          onClose={() => this.props.toggleDrawer(false)}
          PaperProps={{
            style: { minHeight: 225, height: "auto" },
            className: "text-center",
          }}
          onBackdropClick={() => this.props.toggleDrawer(false)}
        >
          <WaitListDrawerContent
            closeDrawer={() => this.props.toggleDrawer(false)}
            waiting_lists={this.props.waiting_lists}
            history={this.props.history}
          />
        </SwipeableDrawer>
      </div>
    );
  }
}
export default withRouter(WaitList);
